import { ErrorMessagesMap } from '../interfaces/errors';
import { Input, Directive } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { DEFAULT_ERROR_MESSAGES, ErrorControlDirective } from './error-control.component';

export const DEFAULT_ITEM_ERROR_MESSAGES: ErrorMessagesMap = {
  maxlength: (err: ValidationErrors) => {
    return `Maximum length of ${err.requiredLength}`;
  },
  minlength: (err: ValidationErrors) => {
    return `Minimum length of ${err.requiredLength}`;
  },
};

@Directive({
  selector: '[formsErrorRepeatedControlFormsSelector]',
  standalone: false,
})
export class ErrorRepeatedControlDirective extends ErrorControlDirective {
  @Input() itemErrorMessages: ErrorMessagesMap = {};

  itemErrorOutput(control: AbstractControl): string {
    if (!control || !control.errors) {
      return;
    }
    const errors = Object.keys(control.errors);
    if (errors.length === 0) {
      return;
    }
    const firstErrorKey = errors[0];
    const messageHandler =
      this.itemErrorMessages[firstErrorKey] ||
      DEFAULT_ITEM_ERROR_MESSAGES[firstErrorKey] ||
      DEFAULT_ERROR_MESSAGES[firstErrorKey];
    if (typeof messageHandler === 'function') {
      return messageHandler(control.errors[firstErrorKey]);
    } else {
      return messageHandler;
    }
  }
}
